import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { SelectInput } from "react-admin";
import { TextField, Typography } from "@material-ui/core";
import { useField } from "react-final-form";
import SetupContext from "./context";
import { NewCustomerStatusOptions } from "../../../../utils/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
}));

export default function Note() {
  const classes = useStyles();
  const { state, dispatch } = useContext(SetupContext);
  const {
    input: { onChange },
  } = useField("setupData");

  const handleRecordChange = (evt) => {
    onChange();
    dispatch({ type: "NOTE", payload: evt.target.value });
  };

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <SelectInput
            choices={NewCustomerStatusOptions}
            source="status"
            label="Status"
            variant="outlined"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">TOS Telemetry: </Typography>
          <Typography>cognitoId: {state.tosAccept.cognitoId} </Typography>
          <Typography>IP Address: {state.tosAccept.ip}</Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="note"
            label="Note"
            id="note"
            autoFocus
            margin="dense"
            multiline
            minRows={10}
            variant="outlined"
            fullWidth
            value={state.note}
            onChange={handleRecordChange}
          />
        </Grid>
      </Grid>
    </div>
  );
}
